import { useIntl } from 'react-intl'
import { subDays, subMonths } from 'date-fns'

import type { DateRangePreset } from '@gto/ui/date-picker'

/**
 * The shared DateRangePicker shortcut set for the admin surfaces (partners,
 * orders, reports). One definition so every picker offers the same windows.
 */
export const useDateShortcuts = (): DateRangePreset[] => {
  const { formatMessage } = useIntl()

  return [
    {
      label: formatMessage({ id: 'common.last7Days' }),
      getValue: () => [subDays(new Date(), 6), new Date()],
    },
    {
      label: formatMessage({ id: 'common.last14Days' }),
      getValue: () => [subDays(new Date(), 13), new Date()],
    },
    {
      label: formatMessage({ id: 'common.lastMonth' }),
      getValue: () => [subMonths(new Date(), 1), new Date()],
    },
    {
      label: formatMessage({ id: 'common.last3Months' }),
      getValue: () => [subMonths(new Date(), 3), new Date()],
    },
  ]
}
